import { apiClient } from './api';
import { AuditLog, PaginatedResponse } from '../types';

interface BackendPaginatedResponse<T> {
  data: T[];
  total: number;
  page: number;
  pages: number;
}

class AuditService {
  async getAuditLogs(filters?: {
    userId?: string;
    actionType?: string;
    startDate?: string;
    endDate?: string;
    page?: number;
    limit?: number;
  }): Promise<PaginatedResponse<AuditLog>> {
    const response = await apiClient.get<BackendPaginatedResponse<AuditLog>>('/admin/audit-logs', filters);
    return {
      items: response.data,
      total: response.total,
      page: response.page,
      limit: filters?.limit || 10,
      totalPages: response.pages
    };
  }
}

export const auditService = new AuditService();
